import { createApp } from "vue";
import { createPinia } from "pinia";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import { ElLoading, ElDatePicker } from "element-plus";
import "@/styles/index.scss";
import "default-passive-events";
import en from "@/language/en";
import cn from "@/language/zh-cn";
import hk from "@/language/zh-hk";

const language: any = localStorage.getItem("language") || "cn";

const i18n = createI18n({
  locale: language, // 设置当前语言环境
  fallbackLocale: "cn", // 当前语言环境未匹配到时，回退到的语言环境
  messages: {
    en,
    cn,
    hk,
  },
});

const pinia = createPinia();
ElDatePicker.props.unlinkPanels = {
  type: Boolean,
  default: true,
};

createApp(App)
  .use(i18n)
  .use(pinia)
  .use(router)
  .use(ElLoading)
  .use(ElDatePicker)
  .mount("#app");
